<ndt-add-account-view
   [callState]="callState$ | async"
   [form]="form"
   [createExtensionTypeOptions]="createExtensionTypeOptions$ | async"
   [locationRequired]="locationRequired"
   (addExtension)="onAddExtension($event)"
   (addPhoneNumber)="onAddPhoneNumber($event)"
   (addLocation)="onAddLocation()"
   (editExtension)="onEditExtension($event)"
   (editLocation)="onEditLocation($event)"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (removeExtension)="onRemoveExtension($event)"
>
</ndt-add-account-view>
